import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

const PHONE_E164_REGEX = /^\+[1-9]\d{6,14}$/

export const useSchema = () => {
  const { t } = useTranslation()

  return Yup.object().shape({
    name: Yup.string().required().max(255),
    phone: Yup.string()
      .optional()
      .default('')
      .test('phone', t('general.validation.invalidPhone'), (value) => !value || PHONE_E164_REGEX.test(value)),
    email: Yup.string().optional().email().default(''),
  })
}

export type CustomerFormValues = Yup.InferType<ReturnType<typeof useSchema>>
